export default __webpack_public_path__ + "static/bankid-358c79bb5ab53235167c8b3e894da69a.jpg";